import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import RowMenu from '../../components/row_menu'
import { Button, EmptyState } from '@cinesend/ui-kit'
import DataTable from '../../components/data_table'
import { Check, PlusCircle } from '@phosphor-icons/react'
import useStore from '../../hooks/use_store'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'

const Lists = ({ schema }) => {
  const { createModel, deleteModel } = useStore()
  const [search, setSearch] = useState('')
  const {
    data: lists,
    error,
    isLoading,
    refetch,
  } = useQuery(['collections', `?schemaID=${schema.id}`, `&search=${search}`])
  const { canEditModel: canEditCollection } = useAuth(modelTypes.Collection)
  const navigate = useNavigate()
  const createList = () => {
    createModel.mutate(
      { endpoint: 'collections', data: { name: 'New List', schema_id: schema.id } },
      {
        onSuccess: (res) => {
          navigate(`${res.data.collection.id}/details`)
        },
      }
    )
  }
  const columns = [
    { key: 'name', header: 'Name', render: (data) => data.name },
    {
      key: 'admin_only',
      header: 'Admin Only',
      render: (data) => (data.admin_only ? <Check size={20} aria-label='Admin only' /> : ''),
    },
    {
      key: 'actions',
      header: '',
      width: '60px',
      render: (data) =>
        canEditCollection && (
          <RowMenu
            label={`Actions for ${data.name}`}
            items={[
              {
                id: 'delete',
                label: 'Delete',
                tone: 'danger',
                onSelect: () =>
                  deleteModel.mutate({
                    endpoint: 'collections',
                    id: data.id,
                    deleteNoun: 'list',
                    deleteName: data.name,
                  }),
              },
            ]}
          />
        ),
    },
  ]

  return (
    <DataTable
      caption='Lists'
      columns={columns}
      rows={lists ?? []}
      onRowClick={(data) => navigate(`${data.id}/details`)}
      isLoading={isLoading}
      error={error}
      onRetry={refetch}
      empty={<EmptyState title='No lists found!' detail='Create a new list to begin.' />}
      searching={{ search, onSearch: setSearch }}
      actions={
        canEditCollection && (
          <Button disabled={createModel.isLoading} leadingIcon={<PlusCircle size={20} />} onClick={() => createList()}>
            Create new list
          </Button>
        )
      }
    />
  )
}

export default Lists
